import { SpeedDialDesignTokens } from '@primeng/themes/types/speeddial';

export const baseSpeedDialToken: SpeedDialDesignTokens = {
  root: {
    gap: '0.75rem',
  },
};
